import Vue from 'vue'
import axios from 'axios'
import moment from 'moment'
import config from '@/config'
import alertHelper from '@/helpers/alert'

const state = {
  selected: {},
  all: [],
  selectedArea: {},
  selectHistoryItem:{},
  nextCheckDate:''
}

const getters = {
  getAll: (state) => {
    return state.all
  },
  getSelected: (state) => {
    return state.selected
  },
  // Returns an area in given inspection
  // Have to pass the inspectionId so we can look up based
  // on the selected inspection
  getArea: (state) => (roomId, areaId) => {
    if (roomId === '' || areaId === '') {
      return {}
    }

    return state.selected[roomId].areas[areaId]
  },
  getSelectedArea: (state) => {
    return state.selectedArea
  },
  getSelectHistoryItem:(state) => {
    return state.selectHistoryItem
  },
  getNextCheckDate:(state) => {
    return state.nextCheckDate
  }
}

const actions = {
  async getAll({ commit, rootGetters }) {
    try {
      const selectedHouse = rootGetters['HouseList/getSelectedHouse']
      const response = await axios.get(
        `${config.apiBaseUrl}house_history/inspectionTimeList`,
        { params: { id: selectedHouse.id } }
      )

      if (response.data.errno === 0) {
        const history = response.data.data;
        commit('setAll', history)
      } else {
        throw new Error(response.data.errmsg)
      }
    } catch (error) {
      alertHelper.error(error)
    }
  },
  get({ commit, dispatch, rootGetters }, inspectionDate) {
    const selectedHouse = rootGetters['HouseList/getSelectedHouse']
    const getWeekBefore = rootGetters['Configuration/getWeekBefore']
    if (Object.keys(selectedHouse).length > 0) {
      if (inspectionDate === 'current') {
        // 如果是当前房间，判断房间是否处于查房状态
        // where.push(`(h.is_inspection = 1 OR  NOW() > DATE_ADD(h.nextcheck_time,INTERVAL ${weekBefore} DAY))`);
        let cNextTime = moment(selectedHouse.nextcheck_time).subtract(getWeekBefore * 7, 'days');
        let isInspection = selectedHouse.inspection_now === 1 || moment().isSameOrAfter(cNextTime)
        if (isInspection) {
          const clonedRoom = JSON.parse(JSON.stringify(selectedHouse.room))
          commit('setSelected', helpers.remapInspection(clonedRoom))
        }else{
          commit('setSelected',[])
          commit('setNextCheckDate',cNextTime)
        }
      } else {
        dispatch('getOldInspection', inspectionDate)
      }
    } else {
      alertHelper.error('Sorry, cannot complete your request. Please select a house.')
    }
  },
  async getOldInspection({ commit, rootGetters }, timestamp) {
    try {
      const selectedHouse = rootGetters['HouseList/getSelectedHouse']
      const inspection = await axios.get(
        `${config.apiBaseUrl}house_history?id=${selectedHouse.id}&timestamp=${timestamp}`
      )
      if (inspection.data.errno === 0) {
          commit('setSelectHistoryItem',inspection.data.data);
          commit('setSelected', helpers.remapInspection(inspection.data.data.room))
      } else {
        throw new Error(inspection.data.errmsg)
      }

    } catch(error) {
      alertHelper.error(error)
    }
  },
  async upload({ getters, dispatch }, { area, file }) {
    try {
      const inspection = getters['getSelected']
      const selectedArea = inspection[area.room_id].areas[area.id]
      const clonedArea = JSON.parse(JSON.stringify(area))

      if (
        Object.keys(inspection).length > 0 &&
        Object.keys(selectedArea).length > 0
      ) {
        const formData = new FormData()
        let endpoint = `${config.apiBaseUrl}img/upload`

        if (area.history_time) {
          endpoint = `${config.apiBaseUrl}house_history/putAreaInfo`
        }

        if (file) {
          const img = {
            id: '',
            areas_id: area.id,
            name: '',
            file_url: file.name,
            create_time: ''
          }

          if (area.history_time) {
            img.history_time = area.history_time
          }

          clonedArea.img.push(img)
          formData.append(`${file.name}`, file, file.name)
        }

        formData.append('area_info', JSON.stringify(clonedArea))
        formData.append('area_id', area.id)
        formData.append('table', 'area')

        await axios.post(
          endpoint,
          formData
        )

        if (area.history_time) {
          dispatch(
            'getOldInspection',
            moment(area.history_time).format('YYYY-MM-DD')
          )
        } else {
          dispatch('updateRoom', area.room_id)
        }
      } else {
        throw new Error('Sorry, cannot upload image. Area doesnt exist.')
      }
    } catch (error) {
      alertHelper.error(error)
    }
  },
  setSelectedArea({ getters, commit }, area) {
    if (Object.keys(area).length > 0) {
      const selectedArea = getters['getArea'](area.room_id, area.id)

      if (selectedArea) {
        commit('updateSelectedArea', area)
      }
    } else {
      commit('updateSelectedArea', {})
    }
  },
  async updateRoom({ getters, commit }, roomId) {
    try {
      let inspection = getters['getSelected']

      if (Object.keys(inspection).length > 0) {
        const response = await axios.get(
          `${config.apiBaseUrl}room/${roomId}/areas`
        )

        if (response.data.errno === 0) {
          const remappedAreas = helpers.remapAreas(response.data.data)
          Object.assign(inspection[roomId].areas, remappedAreas)

          const selectedArea = getters['getSelectedArea']
          if (Object.keys(selectedArea).length > 0) {
            commit('updateSelectedArea', remappedAreas[selectedArea.id])
          }

          commit('setSelected', inspection)
        } else {
          throw new Error(response.data.errmsg)
        }
      } else {
        throw new Error(
          'Inspection is not found. Cannot complete updating the room.'
        )
      }
    } catch (error) {
      alertHelper.error(error)
    }
  },
  async saveArea({ dispatch }, area) {
    let event = 'saveCurrentArea'

    if (typeof area.history_time !== 'undefined') {
      event = 'saveOldArea'
    }

    dispatch(event, area)
  },
  async saveCurrentArea({ getters, commit, dispatch }, area) {
    try {
      const inspection = getters['getSelected']
      const currentArea = inspection[area.room_id].areas[area.id]

      if (
        Object.keys(inspection).length > 0 &&
        Object.keys(currentArea).length
      ) {
        let endpoint = `${config.apiBaseUrl}room/${area.room_id}/areas`
        const response = await axios.put(endpoint, area)

        if (response.data.errno === 0) {
          Object.assign(inspection[area.room_id].areas[area.id], area)

          commit('setSelected', inspection)

          if (Object.keys(getters['getSelectedArea']).length > 0) {
            commit('updateSelectedArea', area)
          }

          // Check if the room status needs changing
          // If all the statuses of areas are complete we can
          // mark the inspection as completed for this room
          const roomInspectionCompleted = Object.values(
            inspection[area.room_id].areas
          ).filter((area) => area.status === '' || area.status === null)

          if (roomInspectionCompleted.length === 0) {
            dispatch('completeRoomInspection', area.room_id)
          }

          alertHelper.success(`${area.area} is successfully updated.`)
        } else {
          throw new Error(response.data.errmsg)
        }
      } else {
        throw new Error('Sorry, cannot save the area. Area doesnt exist.')
      }
    } catch (error) {
      alertHelper.error(error)
    }
  },
  async saveOldArea({ getters, commit, dispatch }, area) {
    try {
      const inspection = getters['getSelected']
      const currentArea = inspection[area.room_id].areas[area.id]

      if (
        Object.keys(inspection).length > 0 &&
        Object.keys(currentArea).length
      ) {
        const formData = new FormData()

        formData.append('area_info', JSON.stringify(area))
        formData.append('area_id', area.id)
        formData.append('table', 'area')

        await axios.post(
          `${config.apiBaseUrl}house_history/putAreaInfo`,
          formData
        )

        dispatch(
          'getOldInspection',
          moment(area.history_time).format('YYYY-MM-DD')
        )
      }
    } catch (error) {
      alertHelper.error(error)
    }
  },
  async completeRoomInspection({ getters, commit }, roomId) {
    try {
      const inspection = getters['getSelected']
      const room = inspection[roomId]

      if (Object.keys(inspection).length > 0 && Object.keys(room).length > 0) {
        const roomData = {
          house_id: room.house_id,
          id: room.id,
          condition: 'Complete',
        }

        const response = await axios.put(
          `${config.apiBaseUrl}house/${room.house_id}/room`,
          roomData
        )

        if (response.data.errno === 0) {
          Object.assign(inspection[roomId], roomData)
          commit('setSelected', inspection)
        } else {
          throw new Error(response.data.errmsg)
        }
      } else {
        throw new Error(
          'Sorry, cannot update room inspection. Room doesnt exist.'
        )
      }
    } catch (error) {
      alertHelper.error(error)
    }
  },
  async generateReport({ dispatch, rootGetters }, sendMail) {
    try {
      const selectedHouse = rootGetters['HouseList/getSelectedHouse']

      if (Object.keys(selectedHouse).length > 0) {
        const response = await axios.post(`${config.apiBaseUrl}img/exportDoc?house_id=${selectedHouse.id}&summary=${selectedHouse.summary}`)

        if (response.data.errno === 0) {
          await dispatch('HouseList/fetchHouse',selectedHouse.id, { root: true })
          // route.go(0)

          if (sendMail === true) {
            dispatch(
              'sendReportMail',
              response.data.data.report_id
            )
          }

          alertHelper.success('Report successfully generated.')
        } else {
          throw new Error(response.data.errmsg)
        }
      } else {
        throw new Error('Cannot generate a report for the house selected.')
      }
    } catch (error) {
      alertHelper.error(error)
    }
  },
  async sendReportMail({ dispatch }, reportId) {
    try {
      if (reportId) {
        const response = await axios.get(
          `${config.apiBaseUrl}img/sendMail`,
          {params: { report_id: reportId }}
        )

        if (response.data.errno === 0) {
          dispatch('getAll')
          alertHelper.success('Report email has been sent successfully.')
        } else {
          throw new Error(response.data.errmsg)
        }
      } else {
        throw new Error(`Cannot send inspection report email for report with id: ${reportId}`)
      }
    } catch (error) {
      alertHelper.error(error)
    }
  },
}

const mutations = {
  setAll(state, data) {
    Vue.set(state, 'all', data)
  },
  setSelected(state, data) {
    Vue.set(state, 'selected', data)
  },
  updateSelectedArea(state, area) {
    Vue.set(state, 'selectedArea', area)
  },
  setSelectHistoryItem(state,data){
    Vue.set(state,'selectHistoryItem',data)
  },
  setNextCheckDate(state,data){
    Vue.set(state,'nextCheckDate',data)
  }
}

const helpers = {
  // This takes inspection rooms, converts them into objects
  // and indexes them by their ids
  remapInspection(inspection) {
    let remapped = {}

    remapped = inspection.reduce((acc, room) => {
      acc[room.id] = {}
      const areasMap = this.remapAreas(room.areas)

      acc[room.id] = room
      delete acc[room.id].areas
      acc[room.id].areas = areasMap

      return acc
    }, {})

    return remapped
  },
  remapAreas(areas) {
    return Object.assign(
      {},
      ...areas.map(area => ({[area.id]: area}))
    )
  }
}

const storeModule = {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations,
}

export default storeModule
